import styled from 'styled-components'
import { InnerModal } from '../Modal/Modal'

export const StyledLegalText = styled.article`
  color: #6c757d;
  text-align: left;
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
  cursor: default;
  overflow-y: auto;
  /* height: calc(100% - 35px); */

  .legal>h4 {
    padding: 20px 0px;
  }

ul > li {
  list-style-type: disc;
  & > li {
    list-style-type: disc;
  }
}
  ol {
    counter-reset: item;
  }

  ol > li {
    counter-increment: item;
  }

  ol ol > li {
    display: block;
  }

  ol ol:not(.alpha) > li:before {
    content: counters(item, ".") ". ";
    margin-left: -20px;
  }
`

export const StyledModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
`

export const StyledInnerModal = styled(InnerModal)`
  border-radius: 3px;
  margin: auto !important;
  z-index: 6;
  width: 80vw;
  height: 80vh;
  padding: 40px 10px 40px 20px;
  background-color: #fff;
  background-clip: padding-box;
  pointer-events: auto;
  outline: 0;
  position: relative;
  display: flex;
  flex-flow: column;

  .modal-content{
    font-size: 12px;
    position: relative;
    display: flex;
    flex-flow: column;
    width: 100%;
    border: 0;
    overflow: auto;

    ol {
      counter-reset: item;
    }

    ol > li {
      counter-increment: item;
    }

    ol ol > li {
      display: block;
    }

    ol ol:not(.alpha) > li:before{
      content: counters(item, ".") ". ";
      margin-left: -20px;
    }
  }
`

export const StyledDeleteTag = styled.div`
  width: 30px;
  height: 30px;
  text-align: center;
  position: absolute;
  top: 5px;
  right: 5px;
  text-transform: lowercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  content: 'x'
  color: #777;
  font: 14px/100% arial, sans-serif;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;

`
